// extracted by mini-css-extract-plugin
export var actions = "components-modals-__SetupAutoload-module___actions";
export var autoloadInfo = "components-modals-__SetupAutoload-module___autoloadInfo";
export var button = "components-modals-__SetupAutoload-module___button";
export var checkboxGroup = "components-modals-__SetupAutoload-module___checkboxGroup";
export var checkboxWrapper = "components-modals-__SetupAutoload-module___checkboxWrapper";
export var label = "components-modals-__SetupAutoload-module___label";
export var plainBtn = "components-modals-__SetupAutoload-module___plainBtn";
export var subTitle = "components-modals-__SetupAutoload-module___subTitle";